import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { AuthService } from './services/auth.service';

@Injectable({ providedIn: 'root' })
export class ManagerOnlyGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        try {
            const userRole = (this.authService.getUserSessionData('ROLE') || '').toLowerCase();
            
            if (userRole === 'admin' || userRole === 'manager') {
                return true;
            }
        } catch (error) {
            console.error('ManagerOnlyGuard: Failed to get user role:', error);
        }
        
        // Use createUrlTree instead of navigate() for proper UrlTree return
        return this.router.createUrlTree(['/home']);
    }
}
